<template>
  <el-card>
    <div slot="header">
      <span>专家列表</span>
    </div>
    <el-tabs v-model="currentTab" type="card" @tab-click="handleClick">
      <el-tab-pane :label="seledTitle" name="Seled"></el-tab-pane>
      <el-tab-pane label="备选专家" name="Opt"></el-tab-pane>
    </el-tabs>
    <div>
      <keep-alive>
        <component
          :is="currentTab"
          :allowEdit="true"
          @handleSeled="handleSeled"
        />
      </keep-alive>
    </div>
  </el-card>
</template>

<script>
import Seled from './Seled.vue';
import Opt from './Opt.vue';

export default {
  data() {
    return {
      loading: false,
      currentTab: 'Seled',
      selfCount: 0,
      seledCount: 0
    };
  },
  computed: {
    seledTitle() {
      return `已选专家(${this.seledCount}人)`;
    }
  },
  components: {
    Seled,
    Opt
  },
  methods: {
    handleClick(tab) {
      this.currentTab = tab.name;
    },
    handleSeled(seledCount) {
      this.seledCount = seledCount;
    }
  },
  created() {}
};
</script>

<style></style>
